export default "__VITE_ASSET__50360e96__"